// extracted by mini-css-extract-plugin
export default {"page":"IX-z","cartModal":"JX-z","checkout":"KX-z","placeholder":"LX-z","account":"MX-z"};